import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { default as AvatarMD } from '@mui/material/Avatar';
import Tooltip from 'components/common/tooltip/Tooltip';

import styles from './Avatar.module.scss';
import _ from 'lodash';

function getAbbreviatedTextContent({ email, firstName, lastName }) {
  if (_.isEmpty(firstName) && _.isEmpty(lastName)) {
    return email[0].toUpperCase();
  }

  let initials = '';
  if (firstName) initials += firstName[0].toUpperCase();
  if (lastName) initials += lastName[0].toUpperCase();
  return initials;
}

function getExpandedTextContent({ email, firstName, lastName }) {
  let content = email || '';
  if (!_.isEmpty(firstName) || !_.isEmpty(lastName)) {
    content = `${firstName} ${lastName}`;
  }

  return content;
}

function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function Avatar(props) {
  const { children, className, email, firstName, lastName, randomizeColor, size, tooltipEnabled } = props;
  const hasTextContent = !_.isEmpty(firstName) || !_.isEmpty(lastName) || !_.isEmpty(email);
  const expandedText = getExpandedTextContent({ email, firstName, lastName });

  function getCustomStyles() {
    let theme = {
      width: size,
      height: size,
    };

    if (randomizeColor && hasTextContent) {
      theme = {
        ...theme,
        bgcolor: stringToColor(expandedText),
      };
    }

    return theme;
  }

  if (!tooltipEnabled) {
    return (
      <AvatarMD className={cx(styles.avatar, className)} sx={{ ...getCustomStyles() }}>
        {children || getAbbreviatedTextContent({ email, firstName, lastName })}
      </AvatarMD>
    );
  }

  return (
    <Tooltip title={expandedText} arrow>
      <AvatarMD className={cx(styles.avatar, className)} sx={{ ...getCustomStyles() }}>
        {children || getAbbreviatedTextContent({ email, firstName, lastName })}
      </AvatarMD>
    </Tooltip>
  );
}

Avatar.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
  className: PropTypes.string,
  email: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  randomizeColor: PropTypes.bool,
  size: PropTypes.number,
  tooltipEnabled: PropTypes.bool,
};

Avatar.defaultProps = {
  className: null,
  firstName: '',
  lastName: '',
  randomizeColor: true,
  size: 36,
  tooltipEnabled: false,
};

export default Avatar;
